/**
 * Group of Related Content Components.
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'alert-banner-config';
const WS = window.sessionStorage;

class AlertBanner extends Component {

    /**
     * Component Setup
     */
    elements = {
        body: document.body
    };

    // Util & State
    alertEvent = new CustomEvent('rockwell-alert', null);
    state = {
        lastModified: null
    };

    /**
     * Initialize Component
     */
    init() {
        const configPagePath = this.element.getAttribute('data-path');
        this.getAlertBannerConfigPage(configPagePath);
    }

    getAlertBannerConfigPage = (url) => {
        fetch(url).then((response) => {
            if(!response.ok) {
                throw new Error('Response failed');
            }
            return response.text();
        }).then((response) => { // Parse HTML for alert banner components
            const alertBannerConfigPage = response;
            const HTMLElement = document.createElement('html');
            HTMLElement.innerHTML = alertBannerConfigPage;
            const alertBannerComponents = [...HTMLElement.querySelectorAll('.alert-banner')];
            const alertBannerToDisplay = this.findAlertBannerToDisplay(alertBannerComponents);
            if (alertBannerToDisplay !== -1 && document.querySelector('header.global-nav')) {
                const header = document.querySelector('header.global-nav');
                this.checkSessionStorage();
                const lastModified = alertBannerComponents[alertBannerToDisplay].querySelector('.alert-banner__container').getAttribute('data-last-modified');
                if (JSON.parse(WS.getItem('rockwell-alert')) !== null && lastModified === JSON.parse(WS.getItem('rockwell-alert')).lastModified) {
                    return;
                }
                header.insertAdjacentElement('beforeBegin', alertBannerComponents[alertBannerToDisplay]);
                alertBannerComponents[alertBannerToDisplay].querySelector('.alert-banner__close').addEventListener('click', this.closeAlertBanner);
                alertBannerComponents[alertBannerToDisplay].querySelector('.alert-banner__close').addEventListener('keydown', (event) => {
                    if (event.keyCode === 13) {
                        this.closeAlertBanner(event);
                    }
                });
            }
        });
    };

    findAlertBannerToDisplay = (alertBannerComponents) => {
        let pagePath = window.location.pathname.split('.')[0];
        if (pagePath.includes('/content/preview')) {
            pagePath = pagePath.replace('/content/preview', '/content');
        }
        let alertBannerToDisplay = -1;
        alertBannerComponents.forEach((alertBannerComponent, index) => {
            let displayPathMatch = false;
            let validTime = false;
            const container = alertBannerComponent.querySelector('.alert-banner__container');
            const onTime = container.getAttribute('data-on-time');
            const offTime = container.getAttribute('data-off-time');
            const bannerType = container.getAttribute('data-type');
            const displayPaths = container.getAttribute('data-display-paths') ? container.getAttribute('data-display-paths').split(',') : [];

            // Check if current time is between onTime and offTime
            const currentTime = new Date();
            const onTimeDate = new Date(onTime);
            const offTimeDate = new Date(offTime);
            if (currentTime > onTimeDate && currentTime < offTimeDate) {
                validTime = true;
            } else {
                return;
            }

            // Check if default alert banner
            if (bannerType === 'default') {
                if (alertBannerToDisplay === -1) {
                    alertBannerToDisplay = index;
                }
                return;
            }

            // Check if current page is in displayPaths
            displayPaths.forEach((displayPath) => {
                if (displayPath === '') {
                    return;
                }
                let path = displayPath.split('?includeChildren=')[0];

                // Currently, there is only NA / EN for Plex. This will need to be updated for other regions in the future.
                if (window.location.origin.includes('rockwellautomation.com')) {
                    path = path.replace('/content/plex/global/na/en', '');
                }

                const includeChildren = displayPath.split('?includeChildren=')[1] === 'true';
                if (includeChildren) {
                    if (pagePath.includes(path)) {
                        displayPathMatch = true;
                    }
                } else if (pagePath === path) {
                    displayPathMatch = true;
                } else if (pagePath.replace('/en-us', '') === path) {
                    displayPathMatch = true;
                }
            });

            if (displayPathMatch && validTime) {
                alertBannerToDisplay = index;
            }
        });
        return alertBannerToDisplay;
    };

    checkSessionStorage = () => {
        this.state = JSON.parse(WS.getItem('rockwell-alert')) === null ? this.state : JSON.parse(WS.getItem('rockwell-alert'));
    };

    updateSessionStorage = () => {
        WS.setItem('rockwell-alert', JSON.stringify(this.state));
    };

    /**
     * Disable Alert Banner
     */
    disableAlert = (lastModified) => {
        this.element.classList.add('alert-banner--closed');
        this.state.lastModified = lastModified;
        this.updateSessionStorage();
        window.dispatchEvent(this.alertEvent);
    };

    closeAlertBanner = (event) => {
        const alertBanner = event.target.closest('.alert-banner');
        alertBanner.classList.add('alert-banner--closed');
        const lastModified = alertBanner.querySelector('.alert-banner__container').getAttribute('data-last-modified');
        this.disableAlert(lastModified);
    };
}

registerComponent(`.${componentName}`, AlertBanner);
